import React from 'react';

import { Skeleton } from '../../Skeleton';

/**
 * Скелетон формы для отправки комментария
 */
export const AddCommentFormSkeleton = () => <Skeleton height={76} />;
